module.exports = __webpack_public_path__ + "img/dypitch-4-mobile.448fab5d.jpg";